/**
 * @desc 查看环保监测曲线
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.EPMonitorRequest,
): Promise<defs.StandardReturn<defs.EPMonitorCurveResponse>> {
  return defHttp.post({
    url: '/web/EPManage/queryEpMonitorCurve',
    data,
  });
}

export function mock(
  data: defs.EPMonitorRequest,
): Promise<defs.StandardReturn<defs.EPMonitorCurveResponse>> {
  return defHttp.post({
    url: '/mock/web/EPManage/queryEpMonitorCurve',
    data,
  });
}
